// extracted by mini-css-extract-plugin
export default {"switchDiv":"switch_switchDiv__KwLFf","switchBtn":"switch_switchBtn__7w4wE"};